$shm_dashboard_admin_server $mol_page
	title \Сервер
	history /
	metric_history /
	tools /
		<= Refresh $mol_button_minor
			title \Обновить
			click? <=> refresh? null
	body /
		<= Summary $mol_view
			sub /
				<= Memory_usage $shm_ba_summary_card
					title \ОЗУ виртуальной машины
					value <= memory_usage \
				<= Memory_available $shm_ba_summary_card
					title \Доступно ОЗУ
					value <= memory_available \
				<= Process_memory $shm_ba_summary_card
					title \PocketBase использует ОЗУ
					value <= process_memory \
				<= Disk_usage $shm_ba_summary_card
					title \Диск
					value <= disk_usage \
				<= Storage_total $shm_ba_summary_card
					title \Файлы PocketBase
					value <= storage_total \
		<= Details $mol_view
			sub /
				<= Storage_panel $mol_view
					sub /
						<= Storage_title $mol_view
							sub / \Хранилище по коллекциям PB
						<= Storage $mol_list
							rows <= storage_rows /
	Storage_row* $mol_view
		sub /
			<= Storage_name* $mol_view
				sub / <= storage_name* \
			<= Storage_files* $mol_view
				sub / <= storage_files* \
			<= Storage_size* $mol_view
				sub / <= storage_size* \
	Empty $mol_view
		sub / \Файлов в коллекциях нет

$shm_dashboard_admin_server_charts $mol_page
	title \История хранилища
	history /
	metric_history /
	body /
		<= Charts $mol_view
			sub /
				<= Disk_chart_title $mol_view
					sub / \Заполнение диска
				<= Disk_chart $mol_chart
					graphs /
						<= Disk_used_line $mol_plot_line
							title \Занято, %
							series_y <= disk_used_series /
						<= Disk_used_dots $mol_plot_dot
							series_y <= disk_used_series /
						<= Disk_ruler $mol_plot_ruler_vert
						<= Disk_mark $mol_plot_mark_cross
							labels <= history_labels /
							graphs / <= Disk_used_line
				<= Pb_chart_title $mol_view
					sub / \Файлы PB
				<= Pb_chart $mol_chart
					graphs /
						<= Pb_storage_line $mol_plot_line
							title \Объём, МБ
							series_y <= pb_storage_series /
						<= Pb_storage_dots $mol_plot_dot
							series_y <= pb_storage_series /
						<= Pb_ruler $mol_plot_ruler_vert
						<= Pb_mark $mol_plot_mark_cross
							labels <= history_labels /
							graphs / <= Pb_storage_line
